// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Bookmark from "./Bookmark.bs.js";

function App(Props) {
  return React.createElement("div", {
              className: "md:flex py-8 lg:px-8 lg:w-1/2 flex-col space-y-2 divide-y-4 divide-gray-300"
            }, React.createElement(Bookmark.make, {
                  title: "Neil Parikh",
                  href: "https://www.neilparikh.me",
                  tags: [
                    "home",
                    "neil",
                    "anotherTag",
                    "yetOneMore",
                    "anotherTag2",
                    "yetOneMore2"
                  ]
                }), React.createElement(Bookmark.make, {
                  title: "Github",
                  href: "https://github.com",
                  tags: [
                    "code",
                    "social"
                  ]
                }));
}

var make = App;

export {
  make ,
  
}
/* react Not a pure module */
